import * as actionTypes from './actionTypes';

interface State {
  data: any;
  isFetching: boolean;
  error: boolean;
}

const initialState: State = {
  data: {},
  isFetching: false,
  error: false
}

export const adsRepublish = (state = initialState, action): State => {
  switch (action.type) {
    case actionTypes.FETCH_ADS_REPUBLISH_REQUEST:
      return {
        ...state,
        isFetching: true
      }
    case actionTypes.FETCH_ADS_REPUBLISH_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: true
      }
    case actionTypes.FETCH_ADS_REPUBLISH_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: false,
        data: action.data
      }
    case actionTypes.CLEAR_ADS_REPUBLISH_DATA:
      return {
        ...state,
        isFetching: false,
        error: false,
        data: {}
      }
    default:
      return state;
  }
}
